import Link from "@/src/components/Link"
import { useRouter } from "@/src/hooks/useRouter"
import { AuthLayout } from "@/components/auth/auth-layout"
import { SocialLoginButton } from "@/components/auth/social-login-button"

export default function RegisterPage() {
  const router = useRouter()

  const handlePhoneRegister = () => {
    router.push("/auth/register/step-2")
  }

  // const handleGoogleRegister = () => {
  //   router.push("/auth/register/step-2")
  // }

  // const handleFacebookRegister = () => {
  //   router.push("/auth/register/step-2")
  // }

  // const handleLineRegister = () => {
  //   router.push("/auth/register/step-2")
  // }

  return (
    <AuthLayout>
      <div className="bg-white rounded-2xl shadow-xl p-8">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">สมัครสมาชิก</h1>
        </div>

        <div className="space-y-4">
          <SocialLoginButton provider="phone" onClick={handlePhoneRegister}>
            สมัครสมาชิกด้วย หมายเลขโทรศัพท์
          </SocialLoginButton>

          {/* <SocialLoginButton provider="google" onClick={handleGoogleRegister} disabled>
            สมัครสมาชิกด้วย Google
          </SocialLoginButton>

          <SocialLoginButton provider="facebook" onClick={handleFacebookRegister} disabled>
            สมัครสมาชิกด้วย Facebook
          </SocialLoginButton>

          <SocialLoginButton provider="line" onClick={handleLineRegister} disabled>
            สมัครสมาชิกด้วย Line
          </SocialLoginButton> */}
        </div>

        <div className="mt-8 text-center">
          <p className="text-gray-600">
            มีบัญชีแล้ว?{" "}
            <Link
              href="/auth/login"
              className="text-green-600 hover:text-green-700 font-medium hover:underline transition-colors"
            >
              <span className="text-brand-red">เข้าสู่ระบบ</span>
            </Link>
          </p>
        </div>
      </div>
    </AuthLayout>
  )
}
